import { ArrowBack, ArrowForward } from '@mui/icons-material';
import { Button, Stack, Typography } from '@mui/material';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import Stepper from './Stepper';

export interface IncidentStepperLayoutProps {
  title: string;
  children: ReactNode;
  stepsLength: number;
  isCurrentStepValid: boolean;
  activeStep: number;
  onPrevious?: () => void;
  onNext?: () => void;
  onBack: () => void;
  onComplete: () => void;
}

export function IncidentStepperLayout({
  title,
  children,
  stepsLength,
  isCurrentStepValid,
  activeStep,
  onPrevious,
  onNext,
  onBack,
  onComplete,
}: IncidentStepperLayoutProps) {
  const { t } = useTranslation('patient-transport');

  const handleBack = () => {
    if (activeStep === 0) {
      onBack();
    } else {
      onPrevious?.();
    }
  };

  const handleNext = () => {
    if (activeStep === stepsLength - 1) {
      onComplete();
    } else {
      onNext?.();
    }
  };

  return (
    <Stack sx={{ height: '100%' }} justifyContent="space-between">
      <Stack spacing={8}>
        <Stack spacing={4}>
          <Typography variant="h4">{title}</Typography>

          {stepsLength > 1 && (
            <Stepper
              steps={Array.from({ length: stepsLength }, (_, i) => ({
                active: i === activeStep,
                completed: i < activeStep,
              }))}
            />
          )}
        </Stack>

        <Stack spacing={3} sx={{ mt: 2, mb: 2 }}>
          {children}
        </Stack>
      </Stack>

      <Stack direction="row" justifyContent="space-between">
        <Button variant="outlined" onClick={handleBack}>
          <ArrowBack sx={{ mr: 2 }} />
          {t('reportIncident.previous')}
        </Button>
        <Button disabled={!isCurrentStepValid} onClick={handleNext}>
          {activeStep === stepsLength - 1 ? t('reportIncident.validate') : t('reportIncident.next')}
          <ArrowForward sx={{ ml: 2 }} />
        </Button>
      </Stack>
    </Stack>
  );
}
